export default "__VITE_ASSET__TSSPwCl$__"